module.exports = __webpack_public_path__ + "Paybycheck@2x-2lfz424.png";